import { gql } from 'react-apollo';

export const updateEvangelist = gql`
  mutation updateEvangelist($input: UpdateEvangelistInput!) {
    updateEvangelist(input: $input) {
      evangelist: evangelist {
        email
        name
        photo {
          small
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/mutations/updateEvangelist.js